import { render, staticRenderFns } from "./rbac_access.vue?vue&type=template&id=03c7b37a&"
import script from "./rbac_access.vue?vue&type=script&lang=js&"
export * from "./rbac_access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports